//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime, formatTrueFalse, downloadFile } from '../../components/helpers.js'
import { EventBus } from '../../EventBus/EventBus.js'
import Table from '../../components/Table/Table.vue'
import { createFieldConfig, Store } from '../../components/QSelectUtils'
import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import StockInventoryTool from './StockInventoryTool.vue'
import { formatAmount, formatFieldAmountDiffRegrading, formatFieldDiffAmount, getToolRegradingRecords, formatRegradingDiffForTool, formatRegradingTypeForTool, onInputAmountReal, deleteConnectedRegradingRecordsWithThis, onWithdrawWithThis, getToolRecordSurplusState, formatUniqueToolName } from './stockInventoryTools.js'
import { getChangedProperties } from '../../components/BusinessProcess/bussinessProcessObjectChanges.js'
import ReportMaterialsImageBtn from '../Report/ReportMaterials/ReportMaterialsImageBtn.vue'

export default {
  name: 'StockInventoryTools',
  components: {
    Table,
    ItemsSearchField,
    ReportMaterialsImageBtn
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data: function () {
    const vm = this

    return {
      loadingFile: false,
      openedEdit: false,
      pagination: {
        rowsPerPage: 25,
        page: 1,
        sortBy: 'order',
        descending: true
      },
      getToolRegradingRecords: getToolRegradingRecords,
      onInputAmountReal: onInputAmountReal,
      formatUniqueToolName: formatUniqueToolName,

      amountRealOptions: [
        { key: 'absent', name: '0', labelName: '(Отсутствует)', value: 0 },
        { key: 'inStock', name: '1', labelName: '(В наличии)', value: 1 },
        { key: 'notChecked', name: '', labelName: '- (Не проверено)', value: null }
      ],

      toolRecordsLocal: [],

      toolRecordsSearchConfig: createFieldConfig(
        new Store({
          fullReadable: false,
          cached: false,
          searchable: true,
          searchValueMinLength: 1,
          searchFiltrationBySource: true,
          proxy: {
            urlBase: '/service/delta/stockInventory/task/tools?splitByParties=true',
            searchParamKey: 'searchPattern',
            filterType: 'stockInventoryTool',
            formId: 'stockInventoryTask',
            clearAll: true,
            selectAll: { },
            get urlParams () {
              const params = {}
              if (vm.record.request.stock) {
                params.stockId = vm.record.request.stock.id
              }
              if (vm.record.request.id && vm.record.request.id != -1) {
                params.requestId = vm.record.request.id
              }
              params.sourceListType = 'allInStock'
              params.sourceListTypeStrict = true
              return params
            }
          }
        }))
    }
  },
  computed: {
    request: function () {
      return this.record.request
    },
    requestProperties: function () {
      return this.record.requestProperties
    },
    propertyConfig: function () {
      return this.record.requestProperties.toolRecords
    },
    toolRecords: function () {
      return this.request.toolRecords || []
    },
    filteredToolRecords: function () {
      return this.toolRecords.filter(r => !r.removed) || []
    },
    regradingRecords: function () {
      return this.request.regradingRecords
    },
    filteredRegradingRecords: function () {
      return this.request.regradingRecords.filter(r => !r.removed) || []
    },
    toolRecordsWithdrawAvailable: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.withdrawAvailable
    },
    toolRecordsWithdrawAccess: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.withdrawAccess && this.toolRecordsWithdrawAvailable
    },
    surplusTransferAvailable: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.surplusTransferAvailable
    },
    surplusTransferAccess: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.surplusTransferAccess && this.surplusTransferAvailable
    },
    surplusTransferConfirmationAccess: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.surplusTransferConfirmationAccess && this.surplusTransferAvailable
    },
    accessEditTools: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.taskEditable
    },
    accessAddAdditional: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultEditable
    },
    accessEditTool: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultEditable
    },
    resultHidden: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultHidden
    },
    accessDeleteAll: function () {
      return this.filteredToolRecords.some(tR => tR.deletable)
    },
    user: function () {
      return this.$store.getters.getUser
    },
    mobile: function () {
      return this.user.view !== 'mobile'
    },
    toolRecordsColumns: function () {
      return this.getToolRecordsColumns()
    },
    additionToolRecordColumns: function () {
      return this.getAdditionToolRecordsColumns()
    }
  },
  watch: {
    toolRecords: {
      handler: function () {
        this.saveToolsToStorage()
        this.validate()
      },
      deep: true
    },
    regradingRecords: {
      handler: function () {
        this.saveToolsToStorage()
      },
      deep: true
    },
    'request.inventoryCompleteness': {
      handler: function () {
        this.saveToolsToStorage()
      }
    }
  },
  beforeDestroy: function () {
    EventBus.$off('delete-tools-from-storage', this.onDeleteToolsFromStorage)
  },
  created: function () {
    if (this.mobile) {
      this.pagination.rowsPerPage = 0
    }

    EventBus.$on('delete-tools-from-storage', this.onDeleteToolsFromStorage)

    this.checkLocalStorageToolsChanges()
  },
  methods: {
    // onInputAmountRealCheckbox: function (value, toolRecord) {
    //   if (value === true) {
    //     this.onInputAmountReal(1, toolRecord)
    //   } else {
    //     this.onInputAmountReal(null, toolRecord)
    //   }
    // },
    getAmountRealOption: function (value, toolRecord) {
      const opt = this.amountRealOptions.find(opt => opt.value === value)
      return opt
    },
    onInputAmountRealSelect: function (opt, toolRecord) {
      // const opt = this.amountRealOptions.find(opt => opt.key === key)
      this.onInputAmountReal(opt.value, toolRecord)
    },
    getToolRecordSurplusState: function (toolRecord) {
      return getToolRecordSurplusState(toolRecord, this.propertyConfig)
    },
    onDeleteToolsFromStorage: function () {
      const stockInventoryTasks = JSON.parse(localStorage.getItem('stockInventoryTasks') || '[]') || []
      const index = stockInventoryTasks.findIndex(record => record.id === this.request.id)
      this.deleteToolsFromStorage(stockInventoryTasks, index)
    },
    checkLocalStorageToolsChanges: function () {
      const stockInventoryTasks = JSON.parse(localStorage.getItem('stockInventoryTasks') || '[]') || []
      const index = stockInventoryTasks.findIndex(record => record.id === this.request.id)

      if (index !== -1 && this.accessEditTool) {
        const stockInventoryTask = stockInventoryTasks[index]

        const clearFromSystemFields = function (array) {
          array.forEach(toolRecord => {
            delete toolRecord.isChecked
            delete toolRecord.removed
          })
        }

        clearFromSystemFields(stockInventoryTask.toolRecords)
        clearFromSystemFields(stockInventoryTask.regradingRecords)

        const currentToolRecords = JSON.parse(JSON.stringify(this.toolRecords))
        clearFromSystemFields(currentToolRecords)

        const currentRegradingRecords = JSON.parse(JSON.stringify(this.regradingRecords))
        clearFromSystemFields(currentRegradingRecords)

        if (this.request.toolRecordsChangeTime && this.request.toolRecordsChangeTime > stockInventoryTask.time || (Date.now() - stockInventoryTask.time) > 24 * 60 * 60 * 1000) {
          this.deleteToolsFromStorage(stockInventoryTasks, index)
        } else if (JSON.stringify(stockInventoryTask.toolRecords) !== JSON.stringify(currentToolRecords) || JSON.stringify(stockInventoryTask.regradingRecords) !== JSON.stringify(currentRegradingRecords)) {
          this.$d_ask({
            callback: (data, action) => {
              if (action === 'yes') {
                this.request.toolRecords = stockInventoryTask.toolRecords
                this.request.regradingRecords = stockInventoryTask.regradingRecords
              } else if (action === 'close') {
                this.deleteToolsFromStorage(stockInventoryTasks, index)
              }
            },
            buttons: {
              yes: 'Да',
              close: 'Отмена'
            },
            header: 'Обнаружен несохранённый список номенклатуры. Применить?'
          })
        }
      }
    },
    deleteToolsFromStorage: function (stockInventoryTasks, index) {
      if (index !== -1) {
        stockInventoryTasks.splice(index, 1)
        localStorage.setItem('stockInventoryTasks', JSON.stringify(stockInventoryTasks))
      }
    },
    saveToolsToStorage: function () {
      if (this.request.id) {
        const stockInventoryTasks = JSON.parse(localStorage.getItem('stockInventoryTasks') || '[]') || []
        const index = stockInventoryTasks.findIndex(record => record.id === this.request.id)

        const newRecord = { id: this.request.id, time: Date.now(), toolRecords: this.toolRecords, regradingRecords: this.regradingRecords }
        if (index !== -1) {
          stockInventoryTasks.splice(index, 1, newRecord)
        } else {
          stockInventoryTasks.push(newRecord)
        }
        localStorage.setItem('stockInventoryTasks', JSON.stringify(stockInventoryTasks))
      }
    },
    validate: function () {
      this.$emit('validate')
    },
    onOpen: function (row) {
      const toolRecord = this.request.toolRecords.find(r => r.id === row.id)
      const dialog = this.$d.dialog(this)
      dialog.show({
        maximized: this.mobile,
        class: 'tool-record--dialog',
        persistent: true,
        headerHidden: true,
        contentComponent: StockInventoryTool,
        contentProps: {
          toolRecord: JSON.parse(JSON.stringify(toolRecord)),
          toolRecordStr: JSON.stringify(toolRecord),
          record: this.record,
          additional: toolRecord.additional,
          additionToolRecordColumns: this.additionToolRecordColumns
        },
        componentHandlers: {
          close: function () {
            dialog.hide()
          },
          save: (newToolRecord) => {
            const toolRecord = this.request.toolRecords.find(r => r.id === newToolRecord.id)
            toolRecord.tool = newToolRecord.tool
            toolRecord.amountReal = newToolRecord.amountReal
            toolRecord.unit = newToolRecord.unit
            toolRecord.photos = newToolRecord.photos
            toolRecord.amountDiff = newToolRecord.amountDiff
            toolRecord.amountDiffType = newToolRecord.amountDiffType
            toolRecord.changeTime = Date.now()
            toolRecord.withdrawTime = newToolRecord.withdrawTime
            toolRecord.withdrawUser = newToolRecord.withdrawUser
            toolRecord.surplusTransferTime = newToolRecord.surplusTransferTime
            toolRecord.surplusTransferUser = newToolRecord.surplusTransferUser
            toolRecord.surplusTransferPhotos = newToolRecord.surplusTransferPhotos
            toolRecord.surplusTransferConfirmationTime = newToolRecord.surplusTransferConfirmationTime
            toolRecord.surplusTransferConfirmationUser = newToolRecord.surplusTransferConfirmationUser
            this.$set(toolRecord, 'edited', true)

            dialog.hide()
          }
        }
      })
    },
    onAddAdditional: function () {
      const dialog = this.$d.dialog(this)
      dialog.show({
        maximized: this.mobile,
        class: 'tool-record--dialog',
        persistent: true,
        headerHidden: true,
        contentComponent: StockInventoryTool,
        contentProps: {
          record: this.record,
          toolRecordStr: null,
          additionToolRecordColumns: this.additionToolRecordColumns,
          additional: true
        },
        componentHandlers: {
          close: function () {
            dialog.hide()
          },
          save: (newToolRecord) => {
            this.request.toolRecords.push({
              id: newToolRecord.id || Date.now(),
              tool: {
                id: newToolRecord.tool && newToolRecord.tool.id,
                key: newToolRecord.tool && newToolRecord.tool.key,
                name: newToolRecord.tool && newToolRecord.tool.name,
                uniqueKey: newToolRecord.tool && newToolRecord.tool.uniqueKey,
                partyNumber: newToolRecord.tool && newToolRecord.tool.partyNumber,
                partyName: newToolRecord.tool && newToolRecord.tool.partyName,
                serialNumber: newToolRecord.tool && newToolRecord.tool.serialNumber,
                serialKey: newToolRecord.tool && newToolRecord.tool.serialKey,
                inventoryNumber: newToolRecord.tool && newToolRecord.tool.inventoryNumber
              },
              amountRecorded: newToolRecord.amountRecorded,
              amountReal: newToolRecord.amountReal,
              amountDiff: newToolRecord.amountDiff,
              amountDiffType: newToolRecord.amountDiffType,
              unit: newToolRecord.unit,
              photos: newToolRecord.photos,
              added: true,
              deletable: true,
              additional: true,
              changeTime: Date.now()
            })

            dialog.hide()
          }
        }
      })
    },
    onAdd: function () {
      this.toolRecordsLocal.splice(0)
      this.toolRecordsLocal.push(
        ...this.request.toolRecords.filter(r => !r.removed)
          .map(record => {
            return {
              id: record.tool && record.tool.id,
              key: record.tool && record.tool.key,
              name: record.tool && record.tool.name,
              uniqueKey: record.tool && record.tool.uniqueKey,
              partyNumber: record.tool && record.tool.partyNumber,
              partyName: record.tool && record.tool.partyName,
              serialNumber: record.tool && record.tool.serialNumber,
              serialKey: record.tool && record.tool.serialKey,
              inventoryNumber: record.tool && record.tool.inventoryNumber,
              _disabled: !record.deletable
            }
          })
      )

      if (this.$refs.selectToolRecords) {
        this.$refs.selectToolRecords.showSelectionDialog()
      }
    },
    onSaveAdd: function (newToolRecords) {
      newToolRecords.forEach(newToolRecord => {
        if (!this.request.toolRecords.filter(r => !r.removed).some(toolRecord => toolRecord && toolRecord.tool && toolRecord.tool.uniqueKey === newToolRecord.uniqueKey)) {
          this.request.toolRecords.push({
            id: Date.now(),
            tool: {
              id: newToolRecord.id,
              key: newToolRecord.key,
              name: newToolRecord.name,
              uniqueKey: newToolRecord.uniqueKey,
              partyNumber: newToolRecord.partyNumber,
              partyName: newToolRecord.partyName,
              serialNumber: newToolRecord.serialNumber,
              serialKey: newToolRecord.serialKey,
              inventoryNumber: newToolRecord.inventoryNumber
            },
            amountRecorded: newToolRecord.amount,
            unit: newToolRecord.unit,
            photos: newToolRecord.photos,
            added: true,
            deletable: true,
            additional: false,
            changeTime: Date.now()
          })
        }
      })

      this.request.toolRecords.forEach(toolRecord => {
        if (!newToolRecords.some(newToolRecord => toolRecord && toolRecord.tool && toolRecord.tool.uniqueKey === newToolRecord.uniqueKey)) {
          this.$set(toolRecord, 'removed', true)
        }
      })
    },
    onDelete: function (toolRecord) {
      if (!toolRecord.deletable) {
        return
      }

      const index = this.request.toolRecords.findIndex(r => r.id === toolRecord.id)
      if (index !== -1) {
        if (this.toolRecords[index].added) {
          this.toolRecords.splice(index, 1)
        } else {
          this.$set(this.toolRecords[index], 'removed', true)
        }

        const regrading = getToolRegradingRecords(toolRecord, this.filteredRegradingRecords).length > 0
        if (regrading) {
          deleteConnectedRegradingRecordsWithThis.call(this, toolRecord, this.regradingRecords)
        }
      }
    },
    onDeleteAll: function () {
      this.filteredToolRecords.forEach(tR => {
        this.onDelete(tR)
      })
    },
    onClickWithdraw: function (toolRecord) {
      toolRecord = this.request.toolRecords.find(r => r.id === toolRecord.id)
      onWithdrawWithThis.call(this, toolRecord, this.filteredRegradingRecords)
    },
    showColumnMobile: function (col) {
      const val = col.value
      const hasColumnValue = val != null && !!val && val.length > 0 && val !== 'Нет'
      return col.showAlways || hasColumnValue
    },
    getTrClass: function (row) {
      if (row._notValid) {
        return 'd-tr--red'
      } else if (row.deleted) {
        return 'd-tr--gray'
      } else if (row.added) {
        return 'd-tr--green'
      }
    },
    getTdStyle: function (col, row) {
      if (col.name === 'amountReal') {
        if (row.amountReal != null) {
          if (row.amountDiffType && row.amountDiffType.id === 'surplus') {
            return this.getColoredTdStyle('#cee5ff', 'black')
          } else if (row.amountDiffType && row.amountDiffType.id === 'shortfall') {
            return this.getColoredTdStyle('#ffcece', 'black')
          } else {
            return this.getColoredTdStyle('#ceffce', 'black')
          }
        }
      } else if (col.name === 'amountDiffRegrading') {
        if (col.value != null) {
          if (col.value === 0) {
            return this.getColoredTdStyle('#ceffce', 'black')
          } else if (col.value.startsWith('+')) {
            return this.getColoredTdStyle('#cee5ff', 'black')
          } else if (col.value.startsWith('-')) {
            return this.getColoredTdStyle('#ffcece', 'black')
          }
        }
      } else if (col.name === 'additional') {
        if (row.additional != null) {
          if (row.additional) {
            return this.getColoredTdStyle('#ffffce', 'black')
          }
        }
      } else if (col.name === 'toolKey') {
        if (row.tool && !row.tool.key) {
          return this.getColoredTdStyle('#ffffce', 'black')
        }
      } else if (col.name === 'toolName') {
        if (row.withdrawTime) {
          return this.getColoredTdStyle('#cecece', 'black')
        }
      }
    },
    getColoredTdStyle: function (bgColor, color, fontWeight = 500) {
      return `font-weight: ${fontWeight} !important;
          background-color: ${bgColor} !important;
          color: ${color} !important;
          border-bottom: solid #e0e0e0 1px;`
    },
    getToolRecordsColumns: function () {
      const columns = [
        // {
        //   name: 'id',
        //   label: 'id',
        //   defaultWidth: 90,
        //   sortable: true
        // },
        {
          name: 'ordinalNumber',
          label: '№ п/п (по порядку)',
          labelTable: '№</br>п/п',
          defaultWidth: 40,
          field: (row) => this.filteredToolRecords.indexOf(row) + 1,
          sortable: true
        },
        {
          name: 'toolName',
          label: 'Номенклатурная позиция',
          field: 'tool',
          format: value => value && value.name || 'Неизвестная позиция',
          sortable: true,

          hidden: this.mobile
        },
        {
          name: 'toolKey',
          label: 'ID номенклатурной позиции в 1С',
          field: 'tool',
          format: value => value && value.key || 'Неизвестная позиция',
          sortable: true
        },
        {
          name: 'partyName',
          label: 'Наименование партии',
          field: 'tool',
          format: value => value && value.partyName || null,
          sortable: true,

          hidden: this.mobile
        },
        {
          name: 'serialNumber',
          label: 'Серийный номер',
          labelTable: 'Серийный</br>номер',
          field: 'tool',
          format: value => value && value.serialNumber || null,
          sortable: false,

          hidden: this.mobile
        },
        {
          name: 'inventoryNumber',
          label: 'Инвентарный номер',
          labelTable: 'Инвентарный</br>номер',
          field: 'tool',
          format: value => value && value.inventoryNumber || null,
          sortable: true,

          hidden: this.mobile
        },
        {
          name: 'amountRecorded',
          label: 'Учтенное количество (по 1С)',
          labelTable: 'Учтенное</br>количество</br>(по 1С)',
          defaultWidth: 80,
          format: formatAmount,
          sortable: true
        },
        {
          name: 'unit',
          label: 'Единица измерения',
          labelTable: 'Единица</br>измерения',
          defaultWidth: 70
        },
        {
          name: 'amountReal',
          label: 'Фактическое количество',
          labelTable: 'Фактическое</br>количество',
          defaultWidth: 80,
          format: formatAmount,
          sortable: true,

          showAlways: true,
          hidden: this.resultHidden
        },
        {
          name: 'amountDiff',
          label: 'Расхождение',
          labelTable: 'Расхождение',
          defaultWidth: 100,
          field: formatFieldDiffAmount,
          sortable: true,

          hidden: this.resultHidden
        },
        {
          name: 'amountDiffRegrading',
          label: 'Расхождение с учетом пересортицы',
          labelTable: 'Расхождение</br>с учетом пересортицы',
          defaultWidth: 100,
          field: row => formatFieldAmountDiffRegrading(row, this.filteredRegradingRecords),
          sortable: true,

          hidden: this.resultHidden
        },
        {
          name: 'regradingRecords',
          label: 'Записи пересортицы',
          labelTable: 'Записи</br>пересортицы',
          defaultWidth: 320,
          field: row => getToolRegradingRecords(row, this.filteredRegradingRecords),
          format: (regradingRecords, row) => regradingRecords.map(regradingRecord => {
            const otherTool = row.id === regradingRecord.toolARecordId ? regradingRecord.toolB : regradingRecord.toolA
            const otherRecordId = row.id === regradingRecord.toolARecordId ? regradingRecord.toolBRecordId : regradingRecord.toolARecordId
            return {
              id: otherRecordId,
              tool: otherTool,
              text: `${formatRegradingDiffForTool(regradingRecord, row)} по причине ${formatRegradingTypeForTool(regradingRecord, row)}:  ${otherTool && formatUniqueToolName(otherTool) || 'Неизвестная позиция'}`
            }
          }),
          sortable: true,

          hidden: this.resultHidden
        },
        {
          name: 'additional',
          label: 'Дополнительная позиция',
          labelTable: 'Дополнительная</br>позиция',
          defaultWidth: 100,
          format: formatTrueFalse,
          sortable: true,

          hidden: this.resultHidden,
          hiddenLabel: this.mobile,
          first: this.mobile
        },
        {
          name: 'regrading',
          label: 'Дополнительная позиция для учета пересортицы',
          labelTable: 'Дополнительная позиция</br>для учета пересортицы',
          defaultWidth: 100,
          field: row => {
            const rowRegradingRecords = getToolRegradingRecords(row, this.filteredRegradingRecords)
            return row.additional && rowRegradingRecords && rowRegradingRecords.length !== 0
          },
          sortable: true,
          format: formatTrueFalse,

          hidden: this.resultHidden,
          hiddenLabel: this.mobile,
          first: this.mobile
        },
        {
          name: 'changeTime',
          label: 'Дата/время изменения',
          format: formatTime,
          defaultWidth: 90,
          sortable: true
        },
        {
          name: 'withdraw',
          label: 'Отозвана',
          format: (withdraw, row) => {
            let text = formatTrueFalse(!!row.withdrawTime)
            if (row.withdrawTime) {
              text += ', ' + formatTime(row.withdrawTime)
            }
            if (row.withdrawUser) {
              text += ', ' + row.withdrawUser
            }
            return text
          },
          sortable: true,

          hiddenLabel: this.mobile,
          first: this.mobile
        },
        {
          name: 'surplusTransfered',
          label: 'Сданы излишки',
          format: (surplusTransfered, row) => {
            let text = formatTrueFalse(!!row.surplusTransferTime)
            if (row.surplusTransferTime) {
              text += ', ' + formatTime(row.surplusTransferTime)
            }
            if (row.surplusTransferUser) {
              text += ', ' + row.surplusTransferUser
            }
            return text
          },
          sortable: true,

          hidden: this.mobile
        },
        {
          name: 'surplusTransferConfirmation',
          label: 'Сдача излишков подтверждена',
          format: (surplusTransferConfirmation, row) => {
            let text = formatTrueFalse(!!row.surplusTransferConfirmationTime)
            if (row.surplusTransferConfirmationTime) {
              text += ', ' + formatTime(row.surplusTransferConfirmationTime)
            }
            if (row.surplusTransferConfirmationUser) {
              text += ', ' + row.surplusTransferConfirmationUser
            }
            return text
          },
          sortable: true,

          hidden: this.mobile
        },
        {
          name: 'surplusState',
          label: 'Статус сдачи излишков',
          format: (surplusState, row) => {
            return this.getToolRecordSurplusState(row)
          },
          sortable: true,

          showAlways: true,
          hidden: !this.mobile,
          hiddenLabel: this.mobile,
          first: this.mobile
        }
      ]

      return this.prepareColumns(columns)
    },
    getAdditionToolRecordsColumns: function () {
      const columns = [
        {
          name: 'name',
          label: 'Наименование номенклатурной позиции',
          labelTable: 'Наименование</br>номенклатурной</br>позиции',
          defaultWidth: 300,
          sortable: true
        },
        {
          name: 'amount',
          label: 'Остаток на данном складе (1С)',
          labelTable: 'Остаток</br>на данном</br>складе (1С)',
          defaultWidth: 80,
          sortable: true,
          format: formatAmount
        },
        {
          name: 'unit',
          label: 'Единица измерения',
          labelTable: 'Единица</br>измерения',
          defaultWidth: 70,
          sortable: true
        },
        {
          name: 'key',
          label: 'ID номенклатурной позиции в 1С',
          labelTable: 'ID номенклатурной</br>позиции в 1С',
          defaultWidth: 140,
          sortable: true
        },
        {
          name: 'partyName',
          label: 'Наименование партии',
          sortable: true
        },
        {
          name: 'serialNumber',
          label: 'Серийный номер',
          labelTable: 'Серийный</br>номер',
          sortable: false
        },
        {
          name: 'inventoryNumber',
          label: 'Инвентарный номер',
          labelTable: 'Инвентарный</br>номер',
          sortable: false
        },
        {
          name: 'nomType',
          label: 'Тип номенклатуры',
          labelTable: 'Тип</br>номен-</br>клатуры',
          defaultWidth: 80,
          sortable: true
        },
        {
          name: 'nomVid',
          label: 'Вид номенклатуры',
          labelTable: 'Вид</br>номенклатуры',
          defaultWidth: 130,
          sortable: true
        },
        {
          name: 'nomAffilation',
          label: 'Принадлежность номенклатуры',
          labelTable: 'Принадлежность</br>номенклатуры',
          defaultWidth: 110,
          sortable: true
        }]

      return this.prepareColumns(columns)
    },
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
        if (column.sortable == null) {
          column.sortable = false
        }
      }

      columns = columns.filter(column => {
        return !column.hidden
      })

      return [
        ...columns.filter(item => item.first === true),
        ...columns.filter(item => item.first !== true)
      ]
    },
    hasChanges: function () {
      const record = this.record
      if (record) {
        const changedProperties = getChangedProperties(record.request, record.requestInitial, this.requestProperties)

        return Object.keys(changedProperties).length !== 0
      } else {
        return false
      }
    },
    onExportTable: function () {
      if (this.hasChanges()) {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              this.$emit('save')
            } else if (action === 'export') {
              return this.exportTable()
            }
          },
          header: 'Сохранить изменения?',
          warning: ['Есть несохранённые изменения'],
          buttons: {
            yes: 'Сохранить',
            export: 'Выгрузить без изменений'
          }
        })
      } else {
        return this.exportTable()
      }
    },
    exportTable: function () {
      this.loadingFile = true

      const reportKey = 'stockInventoryReport'
      const args = {
        requestId: this.record.request.id,
        additionalProperties: {
          filenameData: null // иначе не сформируется название
        }
      }

      const url = '/service/delta/stockInventory/task/gridTemplatedXlsReport'
      const bodyFormData = new FormData()
      bodyFormData.set('reportKey', reportKey)
      bodyFormData.set('args', JSON.stringify(args))

      return downloadFile(url, () => {
        this.loadingFile = false
      }, this, 'POST', bodyFormData)
    }
  }
}

